import { Link, Route, Routes } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import LocationPage from "@/pages/LocationPage";
import AdminGalleryPage from "@/pages/AdminGalleryPage";
import { LOCATIONS } from "@/lib/locations";

function NotFound() {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-5 text-center">
            <h1 className="font-serif text-4xl font-bold text-ink">Siden findes ikke</h1>
            <p className="text-muted-foreground">
                Vi kunne ikke finde den side, du leder efter.
            </p>
            <Link
                to="/"
                className="rounded-full bg-poelse px-6 py-3 text-sm font-semibold text-paper transition-colors duration-200 hover:bg-poelse-deep"
            >
                Tilbage til forsiden
            </Link>
        </div>
    );
}

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />

            {/* One route per old city URL — paths match the old WebsiteBaker
                slugs exactly so existing rankings/links keep resolving. */}
            {LOCATIONS.map((loc) => (
                <Route
                    key={loc.slug}
                    path={`/${loc.slug}`}
                    element={<LocationPage location={loc} />}
                />
            ))}

            <Route path="/admin/gallery" element={<AdminGalleryPage />} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
